import { Box, Paper, Typography, useTheme } from '@mui/material'
import React from 'react'
import { FiAlertTriangle } from 'react-icons/fi'

const RestrictMobile = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        bgcolor: 'background.default'
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: '90%',
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <FiAlertTriangle
          style={{
            fontSize: 60,
            color: theme.palette.error.main,
            marginBottom: 2
          }}
        />
        <Typography variant='h5' component='h1' gutterBottom sx={{ fontWeight: 'bold' }}>
          Desktop Only Content
        </Typography>
        <Typography variant='body1' sx={{ mb: 3, color: 'text.secondary' }}>
          We&apos;re sorry, but this content is only available on desktop devices.
        </Typography>
        <Typography variant='body2' sx={{ color: 'text.secondary' }}>
          Please visit this page on your computer or laptop to access the content.
        </Typography>
      </Paper>
    </Box>
  )
}

export default RestrictMobile
